<template>
  <div class="video-lite container">
    <el-form ref="form" :model="form" :rules="rules" size="small">
      <create-choice
        :contentArr="['短视频/图文带货', '通投广告', '极速推广']"
        @onChange="show = true"
      />

      <div class="choose-product">
        <choose-account title="请选择要推广的商品" type="video" />

        <div class="product">
          <product-selecter :product="product" @onConfirm="onChooseProduct" />
        </div>
      </div>

      <div class="creative-module" v-if="product">
        <add-video
          :videoNum="videoNum"
          :videoMax="7"
          title="为商品添加创意内容"
          rightBtn="根据商品智能生成视频"
          @onConfirm="onConfirm"
        />

        <div class="switch-bottom">
          <p class="title-name">
            抖音主页隐藏视频<el-tooltip placement="top" effect="light">
              <div slot="content">
                <p>隐藏后，用户在你的选择的抖音号的主页看不到新增的视频创意</p>
                <p style="margin-top: 5px; color: #909399">
                  注意：计划自动生成的视频创意将默认隐藏，不跟随设置变化
                </p>
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </p>
          <el-radio-group v-model="form.hide" size="medium">
            <el-radio-button label="隐藏"></el-radio-button>
            <el-radio-button label="不隐藏"></el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="right-lite-video-material" v-if="product">
        <creative-preview :haveVideo="videoNum != 0" />
      </div>

      <delivery-settings :form="form" />

      <form-bottom
        :form="form"
        :show="show"
        @onSubmit="handleRelease"
        @onClose="show = false"
        @onCancel="show = true"
      />
    </el-form>
  </div>
</template>

<script>
import createChoice from "../components/createChoice.vue";
import creativePreview from "../components/creativePreview.vue";
import deliverySettings from "./deliverySetting.vue";
import AddVideo from "../components/addVideo.vue";
import ChooseAccount from "../components/chooseAccount.vue";
import ProductSelecter from "../components/productSelecter.vue";
import FormBottom from "../components/formBottom.vue";
import { submit } from "@/api/chapterMock";

export default {
  components: {
    createChoice,
    creativePreview,
    deliverySettings,
    AddVideo,
    ChooseAccount,
    ProductSelecter,
    FormBottom,
  },
  data() {
    var checkBudget = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error("预算不少于300元，不超过9999999.99元，请正确输入")
        );
      }
      if (isNaN(value)) {
        callback(new Error("仅支持输入数字"));
      } else {
        if (value < 300 || value > 9999999.99) {
          callback(
            new Error("预算不少于300元，不超过9999999.99元，请正确输入")
          );
        } else {
          callback();
        }
      }
    };
    var checkBid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("出价不少于0.1元，不超过10000元"));
      }
      if (isNaN(value)) {
        callback(new Error("仅支持输入数字"));
      } else {
        if (value < 0.1 || value > 10000) {
          callback(new Error("出价不少于0.1元，不超过10000元"));
        } else {
          callback();
        }
      }
    };
    return {
      show: false,
      product: null,
      videoNum: 0,
      form: {
        hide: "隐藏",
        mode: "控成本投放",
        action: "商品购买",
        budget: 300,
        bid: null,
        directional: "智能推荐",
        dateType: "从今天起长期投放",
        startTime: "",
        endTime: "",
        timeIntervalType: "不限",
        adName: "短视频",
        adGroup: "短视频/图文带货-系统默认分组",
        audience: {
          region: "不限",
          regionArr: [],
          audienceType: "正在该地区的用户",
          sex: "不限",
          age: [],
          talent: "不限",
        },
      },
      rules: {
        budget: { validator: checkBudget, trigger: "blur" },
        bid: { validator: checkBid, trigger: "blur" },
      },
    };
  },
  methods: {
    onChooseProduct(val) {
      this.product = val;
    },
    onConfirm(val) {
      this.videoNum = val;
    },
    // 发布计划
    handleRelease() {
      if (!this.product) {
        this.$message.warning("请添加商品");
        this.backTop();
        return;
      } else if (this.videoNum == 0) {
        this.$message.warning("请添加创意内容");
        this.backTop();
        return;
      } else this.handleSubmit();
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // console.log({ ...this.form, ...JSON.parse(this.$route.query.form) });
          this.$confirm(`确定要提交吗？`)
            .then(() => {
              const classChapterId = localStorage.getItem("mockChapterId");
              submit({
                classChapterId,
                content: JSON.stringify({
                  ...this.form,
                  ...JSON.parse(this.$route.query.form),
                }),
              }).then((res) => {
                this.$alert("提交成功", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    window.close();
                  },
                });
              });
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    backTop() {
      this.$el.querySelector(".create-choice").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.video-lite {
  padding-top: 32px;
  padding-left: 50px;
  text-align: left;
  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }
  .choose-product {
    margin-top: 32px;
    .product {
      margin-top: 24px;
      width: 648px;
    }
  }

  .creative-module {
    .switch-bottom {
      margin-top: 32px;
      .title-name {
        margin-bottom: 12px;
        font-weight: 600;
        color: #333;
        line-height: 22px;
      }
      ::v-deep  .el-radio-group {
        .el-radio-button__inner {
          width: 100px;
          height: 34px;
          background: #f2f2f2;
          border: 1px solid transparent;
          color: #333;
          border-radius: 4px;
          &:hover {
            background-color: #eff0fe;
          }
        }
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          color: #194ce5;
          border: 1px solid #194ce5;
          background-color: #fff;
          box-shadow: none;
        }
      }
    }
  }

  .right-lite-video-material {
    position: absolute;
    top: 80px;
    right: calc((100vw - 1150px) / 2);
  }
}
</style>